import { Close } from "@mui/icons-material";
import { Box, Container, IconButton, Modal, Typography } from "@mui/material";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import logo from '../../assets/logos/icare_fulllogo.png';
import { sendReactGAPageView } from "../../consts/helpers";
import TermsAndConContent from "./TermsAndConContent";

export default function TermsAndConModal({ open, handleClose }) {
	const { pathname } = useLocation();
	useEffect(() => {
        sendReactGAPageView(pathname, 'Terms & Conditions of Use');
    }, [pathname])

    return (
        <Modal
            open={open}
            onClose={handleClose}
        >
        <Container maxWidth={'xs'} className='modal-container' sx={{ borderRadius: 0, minHeight: '100vh' }}>
            <Box className='spread-x' sx={{ alignItems: 'center' }}>
                <Typography variant="h6">iCare Terms & Conditions</Typography>
                <IconButton onClick={handleClose}>
                    <Close />
                </IconButton>
            </Box>

            <Box display="flex" justifyContent="center">
                <img src={logo} alt='icare app logo' style={{ maxWidth: 300 }}/>
            </Box>
            <TermsAndConContent />
        </Container>
        </Modal>
   );
}